import { render, staticRenderFns } from "./BaseDropdownSelect.vue?vue&type=template&id=539d5088&"
import script from "./BaseDropdownSelect.vue?vue&type=script&lang=js&"
export * from "./BaseDropdownSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports